import { Box } from '@mui/material';
import { parseEmoji } from '@utils/twemojiUtils';

interface EmojiImageProps {
  emoji: string;
  fontSize?: string | number;
}

/**
 * Renders an emoji as a Twemoji image instead of relying on the OS font.
 * Useful for brand-new emoji code points that most devices can't render as
 * glyphs yet — twemoji parsing outputs an <img class="emoji" alt="{emoji}">,
 * so the original character is preserved as the accessible text.
 */
export const EmojiImage = ({ emoji, fontSize }: EmojiImageProps) => (
  <Box
    component="span"
    dangerouslySetInnerHTML={{ __html: parseEmoji(emoji) }}
    sx={{
      '& img.emoji': {
        height: fontSize ?? '1em',
        width: fontSize ?? '1em',
        verticalAlign: '-0.125em',
        margin: 0,
      },
    }}
  />
);
